<div class="row">
  <div class="col-xs-12">
    <div class="small footer-default">
      {{ 'PARTECIPANT_LTI.RESULTS.SELECT_YEAR' | translate }}
    </div>
    <select
      id="selectYearEl"
      class="form-control"
      name="sel-activity"
      [(ngModel)]="currentYear"
    >
      <option *ngFor="let year of getYears()" [ngValue]="year">
        {{ year }}
      </option>
    </select>

    <div id="widgetsContainer">
      <div id="bonusPayable collapsed" class="widget">
        <div class="widgetHeader">
          <div class="widgetHeaderInfo">
            <div class="small widgetTitle">
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_BANK_WIDGET.TITLE' | translate
              }}
            </div>
            <div class="veryBig widgetAmount">
              {{ formatNumber(getAmount('payable')) }}
            </div>
          </div>
        </div>

        <div class="widgetBody">
          <div class="display-flex-space-between">
            <div class="" style="with: 100%; height: 200px">
              <canvas
                baseChart
                *ngIf="expandPayable"
                [data]="getBonusPayableGraphData()"
                [labels]="getBonusPayableGraphDataLabels()"
                [chartType]="'pie'"
                [options]="getBonusPayableGraphOptions()"
                [colors]="getBonusPayableGraphDataColors()"
                [legend]="'true'"
              ></canvas>
              <canvas
                baseChart
                *ngIf="!expandPayable"
                [data]="getBonusPayableGraphData()"
                [labels]="getBonusPayableGraphDataLabels()"
                [chartType]="'pie'"
                [options]="getBonusPayableGraphOptions()"
                [colors]="getBonusPayableGraphDataColors()"
                [legend]="'true'"
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
